import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=a53c9e50&lang=pug&"
import script from "./StoreDetail.vue?vue&type=script&lang=js&"
export * from "./StoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports